<img src="assets/img/logo/WKAlphaFull-300x99.png" />
<h2 class="p-text-secondary p-text-light p-text-center p-mt-0">Sales Tracking</h2>
<form #f="ngForm" [formGroup]="formGroup" (ngSubmit)="login(f)" class="p-d-flex p-flex-column">
	<input formControlName="email" type="text" class="p-mb-2" pInputText placeholder="Email">
	<input formControlName="password" type="password" class="p-mb-2" pInputText placeholder="Password">
	<button pButton type="submit" label="Login"></button>
</form>
